module.exports = __webpack_public_path__ + "static/media/antigua-beaches-36.11622b3f.jpg";